const reducer = (insuranceValues = {}, { type, payload }) => {
  switch (type) {
    case "response":
      return payload;
    default:
      return insuranceValues;
  }
};

export default reducer;
